import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import moment from 'moment';
const app = createApp(App);
// import gMethod from '@/utils/method';
import { NavBar, Image as VanImage, Toast, Field, Cell, CellGroup, Tabbar, TabbarItem, Swipe, SwipeItem, Button, Icon, Area, Popup, Dialog, Picker, CountDown, PasswordInput, NumberKeyboard, Search, SwipeCell, Switch, RadioGroup, Radio, Checkbox, CheckboxGroup, ActionSheet, TimePicker, Calendar } from 'vant';
import 'lib-flexible/flexible'
import 'vant/lib/index.css'; // 全局引入样式
import '../src/css/upvant.css';
import './iconfont/iconfont.css';
import { showToastMsg, showFailToastMsg, showLoadingToastMsg, closeToastMsg, showDialogMsg, LoadingMsg } from '@/utils/message';
import VueQrcodeReader from 'vue-qrcode-reader';
import { i18n, vantLocales } from './lang';
import SvgIcon from '@/components/SvgIcon/index'; // svg组件
const req = require.context('@/assets/icons/svg', false, /\.svg$/);
const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(req);

//对vant组件进行初始化语言设置
vantLocales(i18n.locale);

// 防止用户修改sessionStorage
window.addEventListener("storage", function (e) {
  sessionStorage.setItem(e.key, e.oldValue);
  localStorage.setItem(e.key, e.oldValue);
});

// window.addEventListener("resize", (e) => {    //监听屏幕大小是否有变化
//   if (gMethod.isMobile()) {
//     router.push({ path: '/' });
//   } else {
//     sessionStorage.removeItem("loginInfo");
//     router.push({ path: '/404' });
//   }
// });

router.beforeEach((to, from, next) => {
  document.title = i18n.global.t('about.title');
  let loginInfo = sessionStorage.getItem('loginInfo') ? JSON.parse(sessionStorage.getItem('loginInfo')) : '';
  if (!loginInfo && to.path != '/404') {  //判断是否绑定了手机号
    if (to.name !== 'LoginView' && from.name !== '/') {
      return next('/')
    }
  }
  next();
})
app.directive('preventReClick', {
  mounted(el, binding) {
    el.addEventListener('click', () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 2000) //2000ms间隔时间
      }
    });
  }
})

window.$t = i18n.global.t; //将方法挂载的window中
// window.prototype = store.state.prototype;
store.state.t = window.$t;
app.config.globalProperties.$moment = moment
app.config.globalProperties.$t = i18n.global.t;  //手动将$t挂载至全局
app.config.globalProperties.showToastMsg = showToastMsg;  //提示
app.config.globalProperties.showFailToastMsg = showFailToastMsg;  //失败
app.config.globalProperties.showLoadingToastMsg = showLoadingToastMsg;  //加载中
app.config.globalProperties.showDialogMsg = showDialogMsg;  //对话框
app.config.globalProperties.closeToastMsg = closeToastMsg;  //关闭
app.config.globalProperties.LoadingMsg = LoadingMsg;  //加载中
app.component('svg-icon', SvgIcon);
app.use(VueQrcodeReader);
app.use(NavBar).use(VanImage).use(Toast).use(Field).use(Cell).use(CellGroup).use(Tabbar).use(TabbarItem).use(Swipe).use(SwipeItem).use(Button).use(Icon).use(Area).use(Popup).use(Dialog).use(Picker).use(CountDown).use(PasswordInput).use(NumberKeyboard).use(Search).use(SwipeCell).use(Switch).use(RadioGroup).use(Radio).use(Checkbox).use(CheckboxGroup).use(ActionSheet).use(TimePicker).use(Calendar);
app.use(store).use(router).use(i18n).mount('#app')
